import React from 'react'
import {
  Card,
  Typography,
  Avatar,
  Button,
  IconButton,
  Tooltip,
  useTheme,
  Box,
  Radio,
  Divider,
  Badge,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { ReactComponent as OpenIcon } from '../../assets/icons/OpenIcon.svg'
import useCustomStyles from '../../hooks/CustomStylesHook'
import Colors from '../../utils/colors.json'
import { useNavigate } from 'react-router-dom'

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    // margin: theme.spacing(1, 0),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    flexWrap: 'no-wrap',
    gap: theme.spacing(1),
  },
  avatarContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    // flexWrap: 'wrap',
  },
  avatar: {
    width: 50,
    height: 50,
    // border: "2px solid #f39c12", // Orange border
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'no-wrap',
  },
  button: {
    minWidth: '130px',
    backgroundColor: theme.customColors.btnBlack,
    borderRadius: '16px',
    fontSize: '12px',
    color: '#FFFFFF',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.customColors.btnBlack,
    },
  },
  buttonSlot: {
    minWidth: '130px',
    backgroundColor: theme.customColors.button,
    borderRadius: '16px',
    fontSize: '12px',
    color: '#FFFFFF',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.customColors.button,
    },
  },
  iconButton: {
    color: theme.customColors.textColorMain,
  },
  label: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: Colors.TEXT_COLOR_TERTIARY,
  },
  value: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: Colors.TEXT_COLOR_MAIN,
  },
  iconCircle: {
    width: 16,
    height: 16,
    backgroundColor: '#FFFFFF',
    borderRadius: '50%',
    border: '2px solid #AFAFAF',
  },
  name: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    color: Colors.TEXT_COLOR_MAIN,
  },
  badge: {
    '& .MuiBadge-badge': {
      fontWeight: 'bold',
      fontSize: '9px',
      backgroundColor: Colors.BADGE_COLOR,
      color: Colors.WHITE_BACKGROUND,
      // boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    },
  },
})

const ProposerCard = ({
  onBookSlot,
  onTriggerPayment,
}: {
  onBookSlot?: () => void
  onTriggerPayment?: () => void
}) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  // eslint-disable-next-line
  const onViewClick = (customerDetails: any) => {
    navigate(`${process.env.PUBLIC_URL}/customerDetails`)
  }

  return (
    <Card className={classes?.card} elevation={0}>
      <Box className={classes?.avatarContainer}>
        {/* <Box className={classes?.iconCircle}></Box> */}
        <Radio></Radio>
        <Badge
          overlap='circular'
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          variant='standard'
          className={classes?.badge}
          badgeContent={'KIMS'}
        >
          <Avatar
            className={classes?.avatar}
            alt='Anya'
            src={`https://i.pravatar.cc/150?img=${Math.random()}`}
          />
        </Badge>
        <Box className={classes?.textContent}>
          <Tooltip title={'Anya'} placement='right'>
            <Typography
              className={classes?.name}
              maxWidth={'220px'}
              noWrap
              textOverflow={'ellipsis'}
              overflow={'hidden'}
            >
              Anya
            </Typography>
          </Tooltip>
          <Typography className={classes?.name}>799983737</Typography>
        </Box>
      </Box>
      <Divider orientation='vertical' flexItem />
      <Box className={classes?.details} minWidth={'130px'}>
        <Typography className={classes?.label}>
          MRN NO - <span className={classes?.value}>8989897</span>
        </Typography>
        <Typography className={classes?.label}>
          ABA ID - <span className={classes?.value}>638638</span>
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem />
      <Box className={classes?.info} minWidth={'100px'}>
        <Typography className={classes?.label}>No. of People</Typography>
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          gap={1}
        >
          <Typography className={classes?.value}>4</Typography>
          <Tooltip title='More information'>
            <InfoOutlinedIcon
              fontSize='small'
              className={classes?.iconButton}
            />
          </Tooltip>
        </Box>
      </Box>
      <Divider orientation='vertical' flexItem />
      <Typography className={classes?.value} minWidth={'100px'}>
        Received Date - <span className={classes?.value}>12/12/1998</span>
      </Typography>
      <Divider orientation='vertical' flexItem />
      <Box className={classes?.actions}>
        <Button
          variant='contained'
          className={classes?.button}
          size='small'
          onClick={onTriggerPayment}
        >
          Trigger Payment
        </Button>
        <Button
          variant='contained'
          className={classes?.buttonSlot}
          size='small'
          onClick={onBookSlot}
        >
          Book Slot
        </Button>
        <IconButton
          className={classes?.iconButton}
          size='small'
          onClick={onViewClick}
        >
          <OpenIcon />
        </IconButton>
      </Box>
    </Card>
  )
}

export default ProposerCard
